import BigNumber from 'bignumber.js';
import Manager from '../classes/manager';

const _managers = [
    new Manager({
        name:        'John Pemtonber',
        id:          'manager-0',
        description: 'MANAGER_00_DESC',
        shop:        'LemonadeStand',
        icon:        'manager_01.png'
    }),
    new Manager({
        name:        'Heide Gerdmann',
        id:          'manager-1',
        description: 'MANAGER_01_DESC',
        shop:        'PaperDelivery',
        icon:        'manager_02.png'
    }),
    new Manager({
        name:        'Neill Bundy',
        id:          'manager-2',
        description: 'MANAGER_02_DESC',
        shop:        'ShoeShop',
        icon:        'manager_03.png'
    }),
    new Manager({
        name:        'Donald McRonald',
        id:          'manager-3',
        description: 'MANAGER_03_DESC',
        shop:        'PizzaDelivery',
        icon:        'manager_04.png'
    }),
    new Manager({
        name:        'Uwe Kamps',
        id:          'manager-5',
        description: 'MANAGER_05_DESC',
        shop:        'Bakery',
        icon:        'manager_05.png'
    }),
    new Manager({
        name:        'Kurt Kette',
        id:          'manager-6',
        description: 'MANAGER_06_DESC',
        shop:        'LampStore',
        icon:        'manager_06.png'
    }),
    new Manager({
        name:        'Susi Ulrich',
        id:          'manager-7',
        description: 'MANAGER_07_DESC',
        shop:        'SoccerTeam',
        icon:        'manager_07.png'
    }),
    new Manager({
        name:        'Steven Boldwin-Mayer',
        id:          'manager-8',
        description: 'MANAGER_08_DESC',
        shop:        'MovieStudio',
        icon:        'manager_08.png'
    }),
    new Manager({
        name:        'Manfred von Wright',
        id:          'manager-9',
        description: 'MANAGER_09_DESC',
        shop:        'Airline',
        icon:        'manager_09.png'
    }),
    new Manager({
        name:        'Josef Jain',
        id:          'manager-10',
        description: 'MANAGER_10_DESC',
        shop:        'Bank',
        icon:        'manager_10.png'
    }),
    new Manager({
        name:        'Ferdinand Benz',
        id:          'manager-11',
        description: 'MANAGER_11_DESC',
        shop:        'CarManufacturer',
        icon:        'manager_11.png'
    }),
    new Manager({
        name:        'Pablo Escocash',
        id:          'manager-12',
        description: 'MANAGER_12_DESC',
        shop:        'DrugRing',
        icon:        'manager_12.png'
    })
];

_managers.map((manager, i) => {
    manager.costs = new BigNumber(1000 * Math.pow(10, i));
    return manager;
});

export default {
    getManagers(cb) {
        return cb(_managers);
    }
};
